export function filterUserInput(value: string): string {
    if (!value) {
        return "";
    }

    return value.trim().replace(/^[^\p{L}\p{N}\/\\]+|[^\p{L}\p{N}\/\\]+$/gu, ""); // Remove non-alphanumeric characters from both start and end, except "/" and "\"
}
